import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
import splitting from 'splitting';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      document.querySelectorAll( '.timeline_year-text' ).forEach( function( year ) {
        if ( /[-–—]/.test( year.innerText ) ) {
          const newString = year.innerText.replace( /[-–—]/, '- ' );
          year.innerHTML = newString;
        }
      } );
      if ( window.hasMotion ) {
        splitting( {target: '.timeline_year-text', by: 'lines'} ).forEach( ( s ) => {
          // Use s.words as the target instead of s.el
          splitting( {target: s.words, by: 'chars', force: true} );
        } );

        const scrollText = gsap.timeline( {
          scrollTrigger: {
            trigger: '.timeline__first-image',
            anticipatePin: true,
            pin: true,
            scrub: 0.2,
            end: () => '+=' + ( window.innerHeight * 6.5 ),
            // smoothChildTiming: true,
            invalidateOnRefresh: true,
          },
        } );

        scrollText.to( '.timeline__scroll-text', {
          duration: 3,
          x: ( window.innerWidth - $( '.timeline__scroll-text' ).width() ) - 50,
        } );

        scrollText.to( '.timeline__scroll-text', {
          duration: 2,
          scale: 2,
        } );

        scrollText.to( '.timeline__first-image', {
          duration: 2,
          backgroundColor: 'transparent',
        } );

        scrollText.to( '.timeline__scroll-text', {
          duration: 2,
          scale: 5,
        }, '<' );

        $( '.timeline__image__wrapper' ).each( function() {
          const animation = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 140px',
              end: 'bottom 140px',
              // markers: true,
              scrub: true,
              anticipatePin: true,
              pin: true,
            },
          } );

          animation.fromTo( $( this ).find( '.fit-image' ), {
            scale: 1,
          },
          {
            scale: 0.75,
          } );
        } );
      }
      $( '.timeline__nav__wrapper' ).height( document.querySelector( '.timeline__nav__item' ).offsetHeight * 5 );

      ScrollTrigger.create( {
        trigger: '.timeline__section',
        pin: '.timeline__nav',
        start: 'start 0%',
        end: 'bottom 100%',
        // pinSpacing: false,
        // markers: true,
      } );

      $( '.timeline__hero__scroll-down__wrapper .scroll-down' ).click( function() {
        let wpadminBarHeight = 0;
        if ( $( '#wpadminbar' ).length > 0 ) {
          wpadminBarHeight = $( '#wpadminbar' ).outerHeight();
        }
        const headerHeight = $( 'header.navbar' ).outerHeight();
        $( 'html,body' ).animate( {
          scrollTop: $( '.timeline__section' ).offset().top - ( headerHeight + wpadminBarHeight ),
        }, 5000 );
        setTimeout( function() {
          $( '.timeline .timeline__section:first-child' ).attr( 'tabindex', '0' ).focus();
        }, 5000 );
      } );

      // console.log( test );

      // console.log( test2 );


      const timelineLength = document.querySelectorAll( '.timeline__nav__item' ).length;

      function forwardTimelineIndex() {
        document.querySelectorAll( '.timeline__nav__item' ).forEach( function( el ) {
          el.dataset.arrivalIndex--;
          el.dataset.departureIndex++;

          if ( el.dataset.arrivalIndex < 0 ) {
            el.dataset.arrivalIndex = timelineLength - 1;
          }

          if ( el.dataset.departureIndex > timelineLength - 1 ) {
            el.dataset.departureIndex = 0;
          }
        } );
      }

      function backwardTimelineIndex() {
        document.querySelectorAll( '.timeline__nav__item' ).forEach( function( el ) {
          el.dataset.arrivalIndex++;
          el.dataset.departureIndex--;

          if ( el.dataset.departureIndex < 0 ) {
            el.dataset.departureIndex = timelineLength - 1;
          }

          if ( el.dataset.arrivalIndex > timelineLength - 1 ) {
            el.dataset.arrivalIndex = 0;
          }
        } );
      }

      $( '.timeline__nav__item' ).each( function( i ) {
        const section = $( this ).find( '.timeline__link' ).attr( 'href' );
        let endTrigger = $( this ).find( '.timeline__link' ).attr( 'href' );

        if ( $( section ).next().hasClass( 'timeline__image' ) ) {
          endTrigger = $( section ).next();
        }

        let moveFrom;
        let moveTo;

        if ( i < 3 ) {
          moveTo = 0;
        }

        if ( i > 2 ) {
          moveTo = -( ( i-2 )/timelineLength * 100 );
        }

        ScrollTrigger.create( {
          trigger: section,
          endTrigger: endTrigger,
          onEnter: () => {
            if ( i !== 0 ) {
              forwardTimelineIndex();
            }
            gsap.to( '.timeline__nav__list', {yPercent: moveTo} );
            $( section ).find( '.timeline_year-text' ).addClass( 'timeline-animated' );
          },
          onEnterBack: () => {
            if ( i !== timelineLength - 1 ) {
              backwardTimelineIndex();
            }
            gsap.to( '.timeline__nav__list', {yPercent: moveTo} );
          },
          onToggle: () => {
            const index = gsap.utils.toArray( '.timeline__nav__item' ).indexOf( this );
            let siblings;

            if ( index - 2 >= 0 && index + 2 < $( '.timeline__nav__item' ).length ) {
              siblings = $( this ).siblings().slice( index - 2, index + 2 );
            } else {
              if ( index - 2 < 0 ) {
                siblings = $( this ).siblings().slice( 0, 4 );
              } else if ( index + 2 >= $( '.timeline__nav__item' ).length ) {
                siblings = $( this ).siblings().slice( -4 );
              }
            }
            $( this ).toggleClass( 'is-active' );
            siblings.toggleClass( 'is-visible' );

            $( siblings[0] ).toggleClass( 'is-leaving' );

            if ( $( siblings[3] ).next() ) {
              $( siblings[3] ).next().toggleClass( 'is-entering' );
            }
          },
          start: 'top 50%',
          end: 'bottom 50%',
          // toggleActions: 'play pause reverse reverse',
          // markers: true,
        } );
      } );
      if ( window.hasMotion ) {
        $( '.timeline__section__image-animation__wrapper' ).each( function() {
          const animation = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 50%',
              // markers: true,
              end: 'bottom top',
              scrub: 0.5,
              onEnter: () => $( this ).addClass( 'timeline-visible' ),
            },
          } );

          animation.fromTo( $( this ).find( '.timeline__section__image-animation' ), {
            yPercent: 10,
          },
          {
            yPercent: -10,
          } );
        } );

        setTimeout( function() {
          ScrollTrigger.refresh();
        }, 200 );
      }

      function linkBoxes( elements ) {
        const boxes = document.querySelectorAll( elements );

        boxes.forEach( function( box ) {
          const link = box.querySelector( 'a' );
          // console.log( link );
          if ( link ) {
            box.addEventListener( 'click', function() {
              link.click();
            } );
          }
        } );
      }

      if ( 'querySelector' in document ) {
        if ( $( '.timeline__video__overlay' ).length > 0 ) {
          linkBoxes( '.timeline__video__overlay' );
        }
      }
    },
    finalize: function() {
      if ( window.hasMotion ) {
        $.fn.digits = function() {
          return this.each( function() {
            $( this ).text( $( this ).text().replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,' ).padStart( 3, '0' ) );
          } );
        };

        setTimeout( function() {
          const $number = $( '.timeline__hero__number' );
          const countTo = $number.data( 'count' );
          $number.removeClass( 'opacity-0' );
          $( {
            countNum: 0,
          } ).animate( {
            countNum: countTo,
          },
          {
            duration: 1500,
            easing: 'linear',
            step: function() {
              $( $number.text( Math.floor( this.countNum ) ) ).digits();
            },
            complete: function() {
              $( $number.text( this.countNum ) ).digits();
              $( '.timeline__hero__large-text' ).addClass( 'visible' );
              $( '.timeline__hero__small-text' ).addClass( 'visible' );
              $( '.timeline__hero__scroll-down__wrapper' ).addClass( 'visible' );
              $( '.timeline__hero-image__wrapper' ).addClass( 'visible' );
            },
          } );
        }, 100 );
      } else {
        const $number = $( '.timeline__hero__number' );
        const countTo = $number.data( 'count' );
        $number.text( countTo );
        $number.removeClass( 'opacity-0' );
        $( '.timeline__hero__large-text' ).addClass( 'visible' );
        $( '.timeline__hero__small-text' ).addClass( 'visible' );
        $( '.timeline__hero__scroll-down__wrapper' ).addClass( 'visible' );
        $( '.timeline__hero-image__wrapper' ).addClass( 'visible' );
      }
    },
  };
  app.registerComponent( 'timeline', COMPONENT );
} )( app );
